export abstract class BaseClickHandler<TInput, TOutput> {
  protected pendingClickResolver: ((value: TOutput) => void) | null = null;

  protected constructor() {
    // Protected constructor to enforce singleton pattern in derived classes
  }

  protected abstract processInput(input: TInput): TOutput;

  handleClick(input: TInput): TOutput {
    const result = this.processInput(input);
    this.resolvePendingClick(result);
    return result;
  }

  protected resolvePendingClick(result: TOutput): void {
    if (this.pendingClickResolver) {
      this.pendingClickResolver(result);
      this.pendingClickResolver = null;
    }
  }

  waitForClick(): Promise<TOutput> {
    return new Promise<TOutput>((resolve) => {
      this.pendingClickResolver = resolve;
    });
  }
}
